(() => {
  const initHero = (hero) => {
    if (!hero || hero.dataset.amaReady) return;
    hero.dataset.amaReady = 'true';
    requestAnimationFrame(() => hero.classList.add('is-ready'));
    const media = hero.querySelector('.ama-hero__media');
    const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduced || !media || hero.dataset.motion === 'off') {
      if (media) media.style.transform = 'none';
      return;
    }
    const strength = { soft: 8, medium: 16, strong: 25 }[hero.dataset.motion] || 16;
    let mx = 0, my = 0, scrollY = 0, raf = 0;
    const paint = () => {
      media.style.transform = `translate3d(${mx * -.35}px,${scrollY * .13 + my * -.2}px,0) scale(1.08)`;
      hero.style.setProperty('--ama-mx', `${mx}px`);
      hero.style.setProperty('--ama-my', `${my}px`);
      raf = 0;
    };
    const schedule = () => { if (!raf) raf = requestAnimationFrame(paint); };
    hero.addEventListener('pointermove', (event) => {
      const r = hero.getBoundingClientRect();
      mx = ((event.clientX - r.left) / r.width - .5) * strength;
      my = ((event.clientY - r.top) / r.height - .5) * strength;
      schedule();
    }, { passive: true });
    addEventListener('scroll', () => {
      const r = hero.getBoundingClientRect();
      if (r.bottom > 0 && r.top < innerHeight) { scrollY = Math.max(0, -r.top); schedule(); }
    }, { passive: true });
  };
  const initAll = (root = document) => root.querySelectorAll('[data-ama-hero]').forEach(initHero);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', () => initAll()) : initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
